import { UserInfo } from "./user.definition";

/**
 * Notification preferences enum
 * Represents the different types of notifications a user can receive
 */
export enum NotificationEnum {
  APPOINTMENTS = "APPOINTMENTS",
  MESSAGES = "MESSAGES",
  REVIEWS = "REVIEWS",
  UPDATES = "UPDATES",
  REMINDERS = "REMINDERS",
  MARKETING = "MARKETING",
}

/**
 * Theme preferences enum
 * Represents the visual theme of the application
 */
export enum ThemeEnum {
  LIGHT = "LIGHT",
  DARK = "DARK",
  SYSTEM = "SYSTEM",
}

/**
 * TimeZone enum
 * Represents the supported timezones in the application
 */
export enum TimeZoneEnum {
  UTC = "UTC",
  AFRICA_DAKAR = "AFRICA_DAKAR",
  AFRICA_NDJAMENA = "AFRICA_NDJAMENA",
}

/**
 * Visibility preferences enum
 * Represents the profile visibility settings
 */
export enum VisibilityEnum {
  PUBLIC = "PUBLIC",
  PRIVATE = "PRIVATE",
  CONTACTS_ONLY = "CONTACTS_ONLY",
}

/**
 * User settings interface
 * Represents all user-specific settings stored in the backend
 */
export interface UserSettings {
  settingsId?: number;
  theme?: ThemeEnum;
  timeZone?: TimeZoneEnum;
  visibility?: VisibilityEnum;
  notifications?: NotificationEnum[];
  appLanguage?: AcceptedLanguages;
  userId?: number;
}

/**
 * Update user settings payload
 * Payload structure for updating user settings via API
 * Matches backend structure from Kotlin data class
 */
export interface UpdateUserSettingsPayload {
  settingsId?: number;
  theme?: ThemeEnum;
  timeZone?: TimeZoneEnum;
  visibility?: VisibilityEnum;
  notifications?: NotificationEnum[];
  appLanguage?: string;
  userId?: number;
}

/**
 * Extended UserInfo with settings
 * Combines user information with their settings
 */
export interface UserWithSettings extends UserInfo {
  settings?: UserSettings;
}

/**
 * Password form interface
 * For password change forms
 */
export interface PasswordForm {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

/**
 * Change password payload
 * Payload structure for changing user password via API
 */
export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export const AcceptedLanguagesEnum = {
  FR: "FR",
  EN: "EN",
  AR: "AR",
};
export type AcceptedLanguages =
  (typeof AcceptedLanguagesEnum)[keyof typeof AcceptedLanguagesEnum];
